var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"automation_view"},[_c('iframe',{ref:"iframeDom",attrs:{"id":"iframeDom","src":_vm.iframeSrc,"frameborder":"0"}}),(_vm.markFlag)?_c('div',{staticClass:"mark"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }